import React from 'react';
import { StructuredData, Breadcrumbs } from '../../components';

const createBreadcrumbs = (name, urlName) => [
  { name: 'Bump Boxes', url: '/' },
  { name: 'Shop', url: '/shop' },
  { name, url: `/products/${urlName}` },
];

const createStructuredData = (productInfo) => {
  const structuredData = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: productInfo.name,
    description: productInfo.description,
    sku: productInfo.sku,
    url: window.location.href,
    brand: productInfo.brand,
    image: productInfo.media.map((item) => item.url),
    ...(productInfo.reviews &&
      productInfo.reviews.length > 0 && {
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: productInfo.averageRating,
          reviewCount: productInfo.reviews.length,
        },
        review: productInfo.reviews.map((reviewItem) => ({
          '@type': 'Review',
          reviewRating: {
            '@type': 'Rating',
            bestRating: '5',
            worstRating: '1',
            ratingValue: reviewItem.stars.toString(),
          },
          author: {
            '@type': 'Person',
            name:
              reviewItem.reviewer && reviewItem.reviewer.name.first
                ? reviewItem.reviewer.name.first
                : 'Anonymous',
          },
          reviewBody: reviewItem.description ? reviewItem.description : '',
        })),
      }),
    offers: {
      '@type': 'Offer',
      priceCurrency: 'USD',
      itemCondition: 'https://schema.org/NewCondition',
      price: productInfo.actualCost,
      availability:
        productInfo.totalQuantity === 0
          ? 'https://schema.org/OutOfStock'
          : 'https://schema.org/InStock',
      url: window.location.href,
      seller: {
        '@type': 'Organization',
        name: 'Bump Boxes',
      },
    },
  };
  return structuredData;
};

const SchemaData = ({ productInfo }) => (
  <>
    <StructuredData data={createStructuredData(productInfo)} />
    <Breadcrumbs
      data={createBreadcrumbs(
        productInfo.name,
        productInfo.urlName?.toLowerCase(),
      )}
    />
  </>
);

export default SchemaData;
